import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import StripeLoading from 'modules/host-payout-methods/components/StripeLoading';
import PayoutFormContextProvider from 'modules/host-payout-methods/context/PayoutFormContext';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncPayoutAccountsContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ '../PayoutAccounts'),
);
const AsyncStripeConnectContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ '../StripeConnect'),
);
const AsyncEditPayoutMethodContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ '../EditPayoutMethod'),
);
const AsyncNewPayoutMethodContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ '../NewPayoutMethod'),
);

const payoutBase = `${basePath}/host/payout`;

export const hostPayoutStripeLoadingRoute: RouteDescriptor = {
  id: 'host-payout.stripe-loading',
  path: `${payoutBase}/stripe-connect/loading/`,
  label: 'Host Payout Stripe Loading',
  audience: 'host',
  layout: 'standalone',
  module: 'host-payout-methods',
};

export const hostPayoutNewMethodRoute: RouteDescriptor = {
  id: 'host-payout.new-method',
  path: `${payoutBase}/new-method`,
  label: 'Host Payout New Method',
  audience: 'host',
  layout: 'navigational',
  module: 'host-payout-methods',
};

export const hostPayoutStripeConnectRoute: RouteDescriptor = {
  id: 'host-payout.stripe-connect',
  path: `${payoutBase}/stripe-connect/`,
  label: 'Host Payout Stripe Connect',
  audience: 'host',
  layout: 'navigational',
  module: 'host-payout-methods',
};

export const hostPayoutEditRoute: RouteDescriptor = {
  id: 'host-payout.edit',
  path: `${payoutBase}/:payoutAccountId`,
  label: 'Host Payout Edit',
  audience: 'host',
  layout: 'navigational',
  module: 'host-payout-methods',
};

export const hostPayoutOverviewRoute: RouteDescriptor = {
  id: 'host-payout.overview',
  path: `${payoutBase}`,
  label: 'Host Payout Overview',
  audience: 'host',
  layout: 'navigational',
  module: 'host-payout-methods',
};

const PayoutRoutes = () => (
  <PayoutFormContextProvider>
    <Routes>
      <Route path="stripe-connect/loading" element={<StripeLoading />} />
      {createNavigationalRoute({
        key: hostPayoutNewMethodRoute.id,
        id: hostPayoutNewMethodRoute.id,
        path: 'new-method',
        component: AsyncNewPayoutMethodContainer,
        showBottomNavigation: true,
        noNavbar: isCordova(),
        nonFixedNavbar: true,
        hideFooter: true,
        handle: createRouteHandle(hostPayoutNewMethodRoute),
      })}
      {createNavigationalRoute({
        key: hostPayoutStripeConnectRoute.id,
        id: hostPayoutStripeConnectRoute.id,
        path: 'stripe-connect',
        component: AsyncStripeConnectContainer,
        showBottomNavigation: true,
        noNavbar: isCordova(),
        nonFixedNavbar: true,
        hideFooter: true,
        handle: createRouteHandle(hostPayoutStripeConnectRoute),
      })}
      {createNavigationalRoute({
        key: hostPayoutEditRoute.id,
        id: hostPayoutEditRoute.id,
        path: ':payoutAccountId',
        component: AsyncEditPayoutMethodContainer,
        showBottomNavigation: true,
        noNavbar: isCordova(),
        nonFixedNavbar: true,
        hideFooter: true,
        handle: createRouteHandle(hostPayoutEditRoute),
      })}
      {createNavigationalRoute({
        key: hostPayoutOverviewRoute.id,
        id: hostPayoutOverviewRoute.id,
        index: true,
        component: AsyncPayoutAccountsContainer,
        showBottomNavigation: true,
        noNavbar: isCordova(),
        nonFixedNavbar: true,
        hideFooter: true,
        handle: createRouteHandle(hostPayoutOverviewRoute),
      })}
    </Routes>
  </PayoutFormContextProvider>
);

export const hostPayoutInternalRoutes = [
  <Route
    key={hostPayoutStripeLoadingRoute.id}
    id={hostPayoutStripeLoadingRoute.id}
    path={hostPayoutStripeLoadingRoute.path}
    handle={createRouteHandle(hostPayoutStripeLoadingRoute)}
    element={<StripeLoading />}
  />,
];

export const hostPayoutContainerRoute = PayoutRoutes;

export const hostPayoutInternalDescriptors = [
  hostPayoutStripeLoadingRoute,
  hostPayoutNewMethodRoute,
  hostPayoutStripeConnectRoute,
  hostPayoutEditRoute,
  hostPayoutOverviewRoute,
];

export default PayoutRoutes;
